<template>
  <div class="container_" ref="container_">
    <el-row ref="conditionRow">
      <el-col :span="24">
        <div v-if="titleViews != '智能联动'" class="grid-content searchTitle_">
          <span>分厂/所属区域</span>
          <el-select
            v-model="branchFactoryId"
            :style="{
              width: '200px',
              marginLeft: '10px',
              height: 'initial !important',
            }"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in branchFactoryList"
              :key="item.branchId"
              :label="item.branch"
              :value="item.branchId"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-left: 30px" class="grid-content searchTitle_">
          <span>排放源名称</span>
          <el-input
            v-model="emNameVal"
            :style="{
              width: '200px',
              marginLeft: '10px',
              height: 'initial !important',
            }"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <a
          v-if="titleViews != '智能联动'"
          style="margin-left: 30px"
          @click="searchDataSource()"
          class="self_btn"
          >查询</a
        >
        <a
          v-else
          style="margin-left: 30px"
          @click="searchDataSourceByDistrictId()"
          class="self_btn"
          >查询</a
        >
        <a
          v-if="titleViews != '智能联动'"
          class="self_btn"
          @click="resetDataSource()"
          >重置</a
        >
        <a v-else class="self_btn" @click="resetDataSourceByDistId()">重置</a>
        <span v-if="titleViews == '智能联动'" class="emission_total"
          >总数{{ getTotal ? getTotal : "--" }}</span
        >
      </el-col>
      <!--el-col :span="5" >
        <div class="grid-content" @click="searchDataSource">
          <el-button>查询</el-button>
        </div>

      </el-col-->
      <!--el-col :span="3">
        <div class="grid-content" @click="resetDataSource">
          <el-button :style="{ marginLeft: '10px' }">重置</el-button>
        </div>
      </el-col-->
    </el-row>
    <el-row v-if="titleViews != '智能联动'">
      <el-col :span="10">
        <div class="grid-content searchTitle_">
          <span style="width: 102px; display: inline-block; text-align: right"
            >清单类型</span
          >
          <el-select
            v-model="emissionType"
            :style="{
              width: '200px',
              marginLeft: '10px',
              height: 'initial !important',
            }"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in emissionList"
              :key="item.nameType"
              :label="item.name"
              :value="item.nameType"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="14" :style="{ textAlign: 'right' }">
        <div class="dot1">•</div>
        <div class="dot1-title">已关联设备</div>

        <div class="dot2">-</div>
        <div class="dot1-title">无需关联设备</div>

        <div class="dot3">•</div>
        <div class="dot1-title">未关联设备</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :data="sourceData"
          :header-cell-class-name="getHeaderCellClass"
          :header-row-class-name="getHeadRowClass"
          :cell-class-name="getCellClass"
          :row-class-name="getRowClass"
          class="source_table"
          ref="sourceTable"
          v-loading="isLoad"
          :element-loading-text="loadStr"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.5)"
          :style="{ marginTop: '10px' }"
          :maxHeight="autoHeight"
          @row-click="rowClick"
          empty-text="--"
        >
          <el-table-column  label="序号" align="center" max-width="90">
            <template #default="scope">
              <span>{{ scope.row.index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="titleViews != '智能联动'"
            prop="branchFactory"
            label="分厂/所属区域"
            width="160"
          >
          </el-table-column>
          <el-table-column
            v-if="titleViews == '智能联动'"
            prop="areaName"
            label="所属区域"
            width="160"
          >
          </el-table-column>
          <el-table-column prop="emName" label="排放源名称" min-width="300">
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            label="关联生产设备"
            width="80"
          >
            <template #default="scope">
              <span
                v-if="scope.row && scope.row.equipmentName === 1"
                class="green-dot"
                >●</span
              >
              <span
                v-else-if="
                  scope.row &&
                  (scope.row.equipmentName === 0 ||
                    scope.row.equipmentName === '0')
                "
                class="red-dot"
                >●</span
              >
              <span
                v-else-if="scope.row && isNaN(scope.row.equipmentName)"
                :title="scope.row.equipmentName"
                class="gray-dot"
                >-</span
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            label="关联治理设备"
            width="80"
          >
            <template #default="scope">
              <span
                v-if="scope.row && scope.row.governmentName === 1"
                class="green-dot"
                >●</span
              >
              <span
                v-else-if="
                  scope.row &&
                  (scope.row.governmentName === 0 ||
                    scope.row.governmentName === '0')
                "
                class="red-dot"
                >●</span
              >
              <span
                v-else-if="scope.row && isNaN(scope.row.governmentName)"
                :title="scope.row.governmentName"
                class="gray-dot"
                >-</span
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            label="关联监测设备"
            width="80"
          >
            <template #default="scope">
              <span
                v-if="scope.row && scope.row.monitorName === 1"
                class="green-dot"
                >●</span
              >
              <span
                v-else-if="
                  scope.row &&
                  (scope.row.monitorName === 0 || scope.row.monitorName === '0')
                "
                class="red-dot"
                >●</span
              >
              <span
                v-else-if="scope.row && isNaN(scope.row.monitorName)"
                :title="scope.row.equipmentName"
                class="gray-dot"
                >-</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { unref } from "vue";
import deviceBar from "@/modules/unorganizedComponents/deviceBar/index.vue";
import { CameraMove } from "../../../../../assets/js/unity3D";
import emissionSourceControll from "../../2_3/BG_intelligentDecision/emissionSourceControll";
import { setPageActive } from '@/utils/platformmonitor.js'
export default {
  //import引入的组件需要注入到对象中才能使用
  inject: [
    "getSourceData",
    "updateSourceData",
    "updateSourceDataByDistId",
    "updateScrollPage",
    "getTotal",
    "updateTotal",
    "getBranchFactoryList",
    "updateInventorySwitch",
    "updateLeftRightPart",
    "updateInventoryId",
    "updateInventoryName",
    "updateFactoryArea",
    "getFactoryArea",
    "updateEmNameVal",
    "getEmNameVal",
    "updateBranchFactoryId",
    "getBranchFactoryId",
    "getPageNo",
    "updatePageNo",
    "updateShedObj",
    "updateVdmArea",
    "updateMaterialArea",
  ],
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      computedName: '无组织排放源清单管理组件',
      paramsList: {
        pageInfo: 'unorganizedList.vue',
        customerId: this.$store.state.customerId,
        nameType: "", //select1Id值
        branchFactoryId: "", //select2Id值
        //      nameId: "", //select3Id值
        process: "",
        processSection: "",
        emName: ""
      },
      inventoryTag: true,
      inventoryId: false,
      sourceData: [],
      autoHeight: 595,
      branchFactoryList: [],
      branchFactoryId: "",
      equipmentName: "",
      governmentName: "",
      monitorName: "",
      input: "",
      pageNo: 1,
      pageSize: 100,
      total: "",
      emNameVal: "",
      isLoad: false,
      loadStr: "拼命加载中",
      delayLoader: "",
      curPage: 1,
      scrollPage: 1,
      scrollPageTimer: "",
      emissionType: "",
      emissionList: [],
    };
  },
  provide: function () {
    return {};
  },
  //计算属性 类似于data概念
  computed: {
    titleViews() {
      return this.$store.state.titleViews;
    },
    sourceDataComputed() {
      return unref(this.getSourceData);
    },
    customerId() {
      return this.$store.state.customerId;
    },
    currentAreaId() {
      return this.$store.state.currentAreaId;
    },
    getHeaderCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          if(obj.rowIndex == 0) {
            return "thClass__";
          } else {
            return "thClass_";
          }
        } else {
          return "thClass";
        }
      };
    },

    getHeadRowClass() {
      return function (obj) {
        return "headTrClass";
      };
    },

    getCellClass() {
      let this_ = this;
      return function (obj) {
        if(this_.customerId == 66) {
          if (obj.columnIndex === 0) {
            return "tdClass_baogang_";
          } else {
            return "tdClass_baogang";
          }
        } else {
          if (obj.columnIndex === 0) {
            return "tdClass_";
          } else {
            return "tdClass";
          }
        }

      };
    },

    getRowClass() {
      return function (obj) {
        return "trClass";
      };
    },
    currentHighlightArea() {
      return this.$store.state.currentHighlightArea;
    },
  },
  //监控data中的数据变化
  watch: {
    getSourceData: {
      handler(newVal, oldVal) {
        this.sourceData = unref(newVal);
      },
      deep: true,
    },
    getBranchFactoryList: {
      handler(newVal, oldVal) {
        let areaList = unref(newVal);
        let areaAll = [
          {
            branchId: "",
            branch: "全厂",
          },
        ];
        areaList && $.merge(areaAll, areaList);
        this.branchFactoryList = areaAll;
      },
      deep: true,
    },
    getFactoryArea: {
      handler(newVal, oldVal) {
        this.branchFactoryId = unref(newVal);
      },
      deep: true,
    },
    getTotal: {
      handler(newVal, oldVal) {
        this.total = unref(newVal);
      },
      deep: true,
    },
    getPageNo: {
      handler(newVal, oldVal) {
        this.pageNo = unref(newVal);
      },
      deep: true,
    },
    getEmNameVal: {
      handler(newVal, oldVal) {
        this.emNameVal = unref(newVal);
      },
      deep: true,
    },
    currentAreaId: {
      handler(newval) {
        if (newval && newval != "") {
          this.searchDataSourceByDistrictId();
        }
      },
    },
    currentHighlightArea(newval) {
      this.$store.state.currentAreaId = newval;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.container_).outerWidth();
    let h = $(that.$refs.container_).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });

    if (this.$store.state.titleViews == "智能联动") {
      this.searchDataSourceByDistrictId();
    } else {
      this.getEmissionList();
    }

    this.getFactoryAreaList();

    this.sourceData = unref(this.getSourceData);

    this.$nextTick(function () {
      /*let tableBody = that.$refs.sourceTable;
      console.log(tableBody);*/

      let tableBody = $(this.$refs.sourceTable.$el)
        .find(".el-table__body-wrapper")
        .get(0);
      tableBody.addEventListener("scroll", () => {
        // 滚动距离
        let scrollTop = tableBody.scrollTop;
        that.getCurPage(scrollTop);
        // 变量windowHeight是可视区的高度
        let windowHeight = tableBody.clientHeight || tableBody.clientHeight;
        // 变量scrollHeight是滚动条的总高度
        let scrollHeight = tableBody.scrollHeight || tableBody.scrollHeight;
        //console.log(scrollTop, windowHeight, scrollHeight);
        if (scrollTop + windowHeight + 100 > scrollHeight) {
          if (
            !that.isLoad &&
            that.total &&
            that.total > that.sourceData.length
          ) {
            if (that.delayLoader) {
              clearTimeout(that.delayLoader);
            }
            that.isLoad = true;
            that.delayLoader = setTimeout(function () {
              that.pageNo = that.pageNo + 1;
              //that.scrollPage = that.pageNo;
              that.updateScrollPage(that.pageNo);
              that.updatePageNo(that.pageNo);
              that.updateSourceData(
                that.branchFactoryId,
                that.pageNo,
                that.pageSize,
                "",
                that.emNameVal,
                that.emissionType,
                "",
                true,
                function (data, total) {
                  that.total = total;
                  that.isLoad = false;
                }
              );
            }, 500);
          } else if (that.total && that.total > that.sourceData.length) {
            that.loadStr = "拼命加载中";
          }
        }
      });
    });

    /*sourceTable.addEventListener("scroll", () => {
      // 滚动距离
      let scrollTop = sourceTable.scrollTop;
      // 变量windowHeight是可视区的高度
      let windowHeight = sourceTable.clientHeight || sourceTable.clientHeight;
      // 变量scrollHeight是滚动条的总高度
      let scrollHeight = sourceTable.scrollHeight || sourceTable.scrollHeight;
      if (scrollTop + windowHeight === scrollHeight) {
        // 获取到的不是全部数据 当滚动到底部 继续获取新的数据
        //if (!this.allData) this.getMoreLog();
        console.log(
          "scrollTop",
          scrollTop + "windowHeight",
          windowHeight + "scrollHeight",
          scrollHeight
        );
      }
    });*/
  },
  //方法集合
  methods: {
    getEmissionList() {
      let that = this;
      let findInventorySelectOneUrl =
        CONFIG.requestName + that.$apiOpt.findInventorySelectOne;
      that.$apiUtils
        .get(findInventorySelectOneUrl, {
          customerId: that.$store.state.customerId,
        })
        .then(function (data) {
          that.emissionList = [];
          that.emissionType = "";
          that.emissionList.push({
            name: "全部",
            nameType: "",
          });
          data &&
            data.forEach((item, i) => {
              that.emissionList.push({
                name: item.name,
                nameType: item.nameType,
              });
            });
        });
    },
    getFactoryAreaList() {
      let that = this;
      let findInventorySelectTwoUrl =
        CONFIG.requestName + that.$apiOpt.findInventorySelectTwo;
      this.$apiUtils
        .get(findInventorySelectTwoUrl, {
          customerId: that.$store.state.customerId,
          type: "",
        })
        .then(function (data) {
          let branchFactoryList = [];
          branchFactoryList.push({
            branch: "全部",
            branchId: "",
          });

          data &&
            data.forEach((item) => {
              branchFactoryList.push({
                branch: item.name,
                branchId: item.nameType,
              });
            });
          that.branchFactoryList = branchFactoryList;
        });
    },
    getCurPage(scrollTop) {
      let that = this;
      if (this.total && $(this.$refs.sourceTable.$el).length > 0) {
        let len = Math.ceil(this.sourceData.length / 100);
        //console.log(len);
        for (let i = 0; i < len; i++) {
          let tmpNode = $(this.$refs.sourceTable.$el)
            .find(".el-table__row")
            .get(i === 0 ? 0 : i * 100 - 1);
          let offsetTop = tmpNode ? tmpNode.offsetTop : null;

          let tmpNode_ = $(this.$refs.sourceTable.$el)
            .find(".el-table__row")
            .get((i + 1) * 100 - 1);
          let offsetTop_ = tmpNode_ ? tmpNode_.offsetTop : null;
          if (
            (offsetTop || offsetTop === 0) &&
            (offsetTop_ || offsetTop_ === 0) &&
            !isNaN(offsetTop) &&
            !isNaN(offsetTop_)
          ) {
            //console.log(offsetTop, offsetTop_);
            let delta = (scrollTop - offsetTop) * (scrollTop - offsetTop_);
            if (delta < 0) {
              if (that.scrollPage != i + 1) {
                if (that.scrollPageTimer) {
                  clearTimeout(that.scrollPageTimer);
                }
                that.scrollPageTimer = setTimeout(function () {
                  that.scrollPage = i + 1;
                  that.updateScrollPage(that.scrollPage);
                }, 500);
              }
            }
          }
        }
      }
    },
    searchDataSource() {
      this.pageNo = 1;
      this.scrollPage = 1;
      this.updateScrollPage(this.pageNo);
      this.updatePageNo(this.scrollPage);
      this.updateSourceData(
        this.branchFactoryId,
        this.pageNo,
        this.pageSize,
        "",
        this.emNameVal,
        this.emissionType,
        "",
        true
      );
      //this.updateSourceData([]);
    },
    searchDataSourceByDistrictId() {
      if (this.currentAreaId) {
        this.pageNo = 1;
        this.scrollPage = 1;
        this.updateScrollPage(this.pageNo);
        this.updatePageNo(this.scrollPage);
        this.updateSourceDataByDistId(
          null,
          this.pageNo,
          this.pageSize,
          null,
          this.emNameVal,
          null,
          null,
          false,
          this.currentAreaId
        );
      }
      //this.updateSourceData([]);
    },
    resetDataSource() {
      this.pageNo = 1;
      this.scrollPage = 1;
      this.updateScrollPage(this.pageNo);
      this.updatePageNo(this.scrollPage);
      this.branchFactoryId = "";
      this.updateBranchFactoryId(this.branchFactoryId);
      this.emNameVal = "";
      this.emissionType = "";
      this.updateEmNameVal(this.emNameVal);
      this.updateSourceData(
        this.branchFactoryId,
        this.pageNo,
        this.pageSize,
        "",
        this.emNameVal,
        this.emissionType,
        "",
        true
      );
    },
    resetDataSourceByDistId() {
      this.pageNo = 1;
      this.scrollPage = 1;
      this.updateScrollPage(this.pageNo);
      this.updatePageNo(this.scrollPage);
      this.branchFactoryId = "";
      this.updateBranchFactoryId(this.branchFactoryId);
      this.emNameVal = "";
      this.emissionType = "";
      this.updateEmNameVal(this.emNameVal);
      this.updateSourceDataByDistId(
        null,
        this.pageNo,
        this.pageSize,
        null,
        "",
        null,
        null,
        false,
        this.currentAreaId
      );
    },
    rowClick(row, column, event) {
      console.log('row',row);
      this.paramsList.emName = this.emNameVal;
      this.$store.commit('getEmissionItem',row);
      let params_emission = JSON.parse(JSON.stringify(this.paramsList));
      setPageActive("排放源清单管理-3*3", "open", 1);
      this.$store.commit("getParamsEmission", { params_emission });
      if (row.isVdm) {
        this.updateVdmArea({
          shedId: row.shedId,
          shedNo: row.shedId,
          shedName: row.emName,
          curTime: new Date().getTime(),
        });
        this.updateInventorySwitch(false);
        this.updateLeftRightPart(false);
        this.updateInventoryId(false);
      } else {
        if (
          this.customerId == 38 &&
          this.$store.state.titleViews == "智能联动"
        ) {
          let JsonData = {
            dataList: [],
            processId: "ererererrr",
            callBackFunc: "ReturnScreenPos",
          };
          setTimeout(() => {
            CameraMove({
              longitude: row.longitude.toString(),
              latitude: row.latitude.toString(),
              xDeg: -8,
              yDeg: 36,
              distance: 830,
            });
          }, 100);
          let inventoryId = row.emissionSourceNo;
          let inventoryName = row.emissionSourceName;

          this.updateFactoryArea(
            this.branchFactoryId,
            this.emNameVal,
            true,
            false
          );
          //this.updateInventorySwitch(false);
          //this.updateLeftRightPart(false);

          let that = this;
          setTimeout(function () {
            that.updateInventoryId({
              inventoryId: inventoryId,
              inventoryName: inventoryName,
            });
            that.updateInventorySwitch(true);
            that.updateLeftRightPart(true);
            //that.updateInventoryName(inventoryName);
          });
          return;
        }
        let inventoryId = row.inventoryId;
        let inventoryName = row.emName;

        this.updateFactoryArea(
          this.branchFactoryId,
          this.emNameVal,
          true,
          false
        );
        //this.updateInventorySwitch(false);
        //this.updateLeftRightPart(false);

        let that = this;
        setTimeout(function () {
          that.updateInventoryId({
            inventoryId: inventoryId,
            inventoryName: inventoryName,
          });
          that.updateInventorySwitch(true);
          that.updateLeftRightPart(true);
          //that.updateInventoryName(inventoryName);
        });
      }

      // if (row.isVdm) {
      //   this.updateVdmArea({
      //     shedId: row.shedId,
      //     shedNo: row.shedId,
      //     shedName: row.emName,
      //     curTime: new Date().getTime(),
      //   });
      //   this.updateInventorySwitch(false);
      //   this.updateLeftRightPart(false);
      //   this.updateInventoryId(false);
      // } else {

      //     // this.inventoryTag = true;
      //     // this.inventoryId = '170';
      //     // if(!row.longitude) {
      //     //   row.longitude = "120.726171"
      //     //   row.latitude = "31.855127"
      //     // }
      //     // let cameJSON = { longitude: row.longitude, latitude:row.latitude, xDeg:200, yDeg:50, distance: 200 }
      //     // CameraMove(cameJSON)
      //   }
      //   if (true) {
      //     //this.customerId == 38 && this.$store.state.titleViews == "无组织"
      //     let inventoryId = row.inventoryId;
      //     let inventoryName = row.emName;

      //     this.updateFactoryArea(
      //       this.branchFactoryId,
      //       this.emNameVal,
      //       true,
      //       true
      //     );

      //     //this.updateInventorySwitch(false);
      //     //this.updateLeftRightPart(false);

      //     let that = this;
      //     setTimeout(function () {
      //       that.updateInventoryId({
      //         inventoryId: inventoryId,
      //         inventoryName: inventoryName,
      //       });
      //       that.updateInventorySwitch(true);
      //       that.updateLeftRightPart(true);
      //       //that.updateInventoryName(inventoryName);
      //     });
      //   }
      // }
      //}
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
.searchTitle_ {
  .el-select {
    border-radius: 2px !important;
    border: 1px solid !important;
    border-image: linear-gradient(
        90deg,
        rgba(46, 49, 255, 1),
        rgba(1, 176, 191, 1)
      )
      1 1 !important;
    height: 32px !important;
  }
  .el-select .select-trigger .el-input .el-input__inner {
    height: 32px !important;
    background: linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.64) 0%,
      rgba(11, 10, 34, 0.55) 100%
    ) !important;
    box-shadow: 0px 0px 6px 0px #000000 !important;
    opacity: 1 !important;
    border: none !important;
  }

  .el-input {
    border-radius: 2px !important;
    border: 1px solid !important;
    border-image: linear-gradient(
        90deg,
        rgba(46, 49, 255, 1),
        rgba(1, 176, 191, 1)
      )
      1 1 !important;
  }
  .el-input .el-input__inner {
    height: 28px !important;
    background: linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.64) 0%,
      rgba(11, 10, 34, 0.55) 100%
    ) !important;
    box-shadow: 0px 0px 6px 0px #000000 !important;
    opacity: 1 !important;
    border: none !important;
  }
}

.container_ {
  pointer-events: all;
  .source_table {
    border: 1px solid #84aaff40 !important;
    background: #01132d40 !important;
  }
  .thClass {
    background: #01122ba6 !important;
    border-bottom: 1px solid #cccccc28 !important;
  }

  .thClass > .cell {
    font-size: 16px !important;
    color: #47ffddff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
  }

  .thClass_ {
    background: #01122ba6 !important;
    border-right: 1px solid rgba(132, 170, 255, 0.5) !important;
    border-bottom: 1px solid #cccccc28 !important;
  }

  .thClass_ > .cell {
    font-size: 16px !important;
    color: #bbbbbbff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
  }

  .thClass__ {
    background: #01122ba6 !important;
    border-right: 1px solid rgba(132, 170, 255, 0.5) !important;
    border-bottom: 1px solid #cccccc28 !important;
  }

  .thClass__ > .cell {
    font-size: 16px !important;
    color: #47ffddff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
  }

  .tdClass {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #01122b66 !important;
  }
  .tdClass > .cell {
    font-size: 16px !important;
    color: #bbbbbbff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .tdClass_baogang {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #01122b66 !important;
    > .cell {
      font-size: 16px !important;
      color: #fff !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .tdClass_ {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #0b336b40 !important;
  }

  .tdClass_ > .cell > div {
    font-size: 16px !important;
    color: #888888ff !important;
    font-family: "fontNormal" !important;
    text-align: center !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .tdClass_baogang_ {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #0b336b40 !important;
    .cell > div {
      font-size: 16px !important;
      color: #fff !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .headTrClass {
    border: 1px solid rgba(132, 170, 255, 0.5) !important;
  }
}
</style>
<style scoped lang="scss">
.allListBtn {
  color: #4be0ff;
  position: absolute;
  right: 50px;
  top: 50px;
}

.green-dot {
  color: #99f5ffff;
  line-height: 16px;
  font-size: 30px;
}

.red-dot {
  color: #ff7f7fff;
  line-height: 16px;
  font-size: 30px;
}

.gray-dot {
  color: #cccccccc;
  line-height: 16px;
  font-size: 30px;
}

.container_ {
  position: absolute;
  height: 720px;
  width: 100%;
  margin-top: 55px !important;
  padding: 10px 32px 20px 32px !important;
  pointer-events: all;
}

.searchTitle_ {
  display: inline-block;
  span {
    font-size: 16px;
    font-family: "fontNormal";
    color: #99f5ff;
  }
}

.self_btn {
  background-image: url("img/btn.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.22);
  border-radius: 2px;
  width: 90px;
  height: 45px;
  line-height: 40px;
  display: inline-block;
  cursor: pointer;
}

/*.self_btn:hover{
 background-image: url("img/btn_click.png");
}*/

.self_btn:active {
  background-image: url("img/btn_click.png");
}

.dot1 {
  font-size: 60px;
  color: #99f5ffff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
}

.dot2 {
  font-size: 60px;
  color: #4d4d4dff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot3 {
  font-size: 60px;
  color: #ff7f7fff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot1-title {
  font-size: 16px;
  font-family: "fontNormal";
  color: #c8dde1ff;
  display: inline-block;
  line-height: 50px;
  height: 40px;
}
.emission_total {
  color: #47ffddff;
  width: 120px;
  height: 40px;
  font-size: 30px;
  font-weight: 700;
  display: block;
  float: right;
  font-style: italic;
}
</style>
